import { render, staticRenderFns } from "./welcomeBeforeSession.vue?vue&type=template&id=89006a8e&scoped=true"
import script from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
export * from "./welcomeBeforeSession.vue?vue&type=script&lang=js"
import style0 from "./welcomeBeforeSession.vue?vue&type=style&index=0&id=89006a8e&prod&scoped=true&lang=less"
import style1 from "./welcomeBeforeSession.vue?vue&type=style&index=1&id=89006a8e&prod&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89006a8e",
  null
  
)

export default component.exports